const Badge = ({ children }) => {
  return (
    <span className="inline-flex rounded-full bg-teal-100 px-4 py-1 text-xs font-semibold uppercase leading-5 tracking-wide text-teal-700 sm:text-sm">
      {children}
    </span>
  )
}

export default Badge
